import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../helper";

// ============================================
// 🔒 PrivateRoute — เส้นทางที่ต้อง login ก่อน
// ============================================
// ก่อนหน้านี้เป็น "stub" เปล่า ๆ → ทุกคนเข้าได้แม้ไม่ login (ช่องโหว่!)
// ตอนนี้แก้แล้ว: ถ้าไม่ login → redirect ไป /login พร้อมเก็บตำแหน่งเดิมไว้
// หลัง login สำเร็จ → Login.js อ่าน ?redirect= แล้วกลับมาหน้าที่จะเข้า

const LOGIN_PATH = "/login";

function PrivateRoute({ component: Component, headerTitle, ...rest }) {
  const isAuth = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        // กรณี 1: ยังไม่ login → เก็บ redirect ไว้ แล้วส่งไปหน้า login
        if (!isAuth) {
          return (
            <Redirect
              to={{
                pathname: LOGIN_PATH,
                search: `?redirect=${encodeURIComponent(
                  props.location.pathname + props.location.search
                )}`,
                state: { from: props.location },
              }}
            />
          );
        }

        // กรณี 2: login แล้ว → แสดงหน้าปกติ
        return (
          <div>
            <Component {...props} />
          </div>
        );
      }}
    />
  );
}

export default PrivateRoute;
